export default "__VITE_PUBLIC_ASSET__b9599e93__"